import React from "react";
import _ from "lodash";
import { Separator, Text } from "@showitinc/showit-wc";
import ButtonBar from "../SetupButtonBar";
import ViewPanel from "../ViewPanel";
import HelpConstants from "../../../constants/HelpConstants";

function migrationRequestComplete() {
  return (
    <div>
      <Text variant="heading-2" variantStyle="strong">
        Your migration request has been received!
      </Text>
      <Separator />
      <p>
        Once your blog is set up, we will contact you with instructions to point your domain name to
        your new blog server.
      </p>
      <p>
        After you have configured your domain DNS settings, please contact support to add an SSL
        certificate. This will secure your website and complete the domain setup process.
      </p>
      <br />
      <p>
        See{" "}
        <a href={HelpConstants.URL_BLOG_SETUP} target="_blank" rel="noreferrer">
          this article
        </a>{" "}
        for estimated turnaround time on your migration.
      </p>
      <p>
        <strong>
          Starting now, please refrain from entering new posts or changes to your blog as those may
          be lost during migration. Once we notify you that it is ready, you can resume your blog
          posting.
        </strong>
      </p>
    </div>
  );
}

function newBlogRequestComplete() {
  return (
    <div>
      <Text variant="heading-2" variantStyle="strong">
        Your new blog request has been received!
      </Text>
      <Separator />
      <p>
        Once your blog is set up, we will contact you with instructions to point your domain name to
        your new blog server.
      </p>
      <p>
        After you have configured your domain DNS settings, please contact support to add an SSL
        certificate. This will secure your website and complete the domain setup process.
      </p>
      <br />
      <p>
        See{" "}
        <a href={HelpConstants.URL_BLOG_SETUP} target="_blank" rel="noreferrer">
          this article
        </a>{" "}
        for estimated turnaround time on your new blog.
      </p>
    </div>
  );
}

function setupRequestUpdated() {
  return (
    <div>
      <Text variant="heading-2" variantStyle="strong">
        Request Updated
      </Text>
      <Separator />
      <p>Thank you for updating your information.</p>
      <p>
        Once your blog is set up, we will contact you with instructions to point your domain name to
        your new blog server.
      </p>
      <p>
        After you have configured your domain DNS settings, please contact support to add an SSL
        certificate. This will secure your website and complete the domain setup process.
      </p>
      <br />
      <p>
        See{" "}
        <a href={HelpConstants.URL_BLOG_SETUP} target="_blank" rel="noreferrer">
          this article
        </a>{" "}
        for estimated turnaround time on your new blog.
      </p>
    </div>
  );
}

function Complete({ blogSetup, actions }) {
  const { migrationRequired, isNewRequest } = blogSetup;
  let view = null;

  if (isNewRequest) {
    view = migrationRequired ? migrationRequestComplete() : newBlogRequestComplete();
  } else {
    view = setupRequestUpdated();
  }

  return (
    <ViewPanel>
      {{
        content: view,
        actions: (
          <ButtonBar
            onForward={actions.close}
            allowForward
            allowBack={false}
            forwardBtnText="Done"
          />
        ),
      }}
    </ViewPanel>
  );
}

export default Complete;
